{
  "access-denied-user": "O utilizador não tem permissão de acesso à web",
  "activation": "Ativação",
  "code": "Código",
  "code-sent": "Código enviado",
  "contact": "Contacto",
  "enter": "Entrar",
  "error-text": "Erro",
  "mail": "E-mail",
  "new-version-available": "Nova versão disponível",
  "password": "Senha",
  "resend-wait": "Aguarde {{seconds}}s para reenviar",
  "server-apologies": "Lamentamos o inconveniente",
  "server-maintenance": "Servidor em manutenção",
  "translation-load-error": "Erro ao carregar as traduções",
  "user": "Usuário",
  "user-or-password-incorrect": "Utilizador ou palavra-passe incorreta",
  "wait": "Por favor, aguarde"
}